<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
            <v-flex xs12 sm7 md7 class="cont-img">
                <video :src="url" buffered controls 
                       :width="widthVideo" 
                       controlslist="nodownload"
                       @ended="$store.commit('nextShow',true)" 
                ></video>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
        'A Região Nordeste tem 9 estados: Alagoas, Ceará, Maranhão, Paraíba, Pernambuco, Piauí, Rio Grande do Norte, Bahia e Sergipe.',
        'Clique no vídeo e conheça Salvador, capital do estado da Bahia e primeira capital do Brasil.'
            ],
            widthVideo:'100%',
            url:  'videos/ibraco-presentacion-1.mp4',
        }
    }
}
</script>